
export default function WhatWeDo() {
  const solutions = [
    {
      title: 'Workflow Optimization',
      description: 'Standardize processes, eliminate inefficiencies, and bring structure to daily operations.',
      icon: 'ri-flow-chart'
    },
    {
      title: 'Intelligent Automation',
      description: 'Apply AI-assisted automation to reduce manual effort and support better execution.',
      icon: 'ri-robot-2-line'
    },
    {
      title: 'Systems Integration',
      description: 'Connect CRMs, ERPs, scheduling, payroll, and internal tools into cohesive workflows.',
      icon: 'ri-links-line'
    },
    {
      title: 'Decision Support',
      description: 'Design systems that surface insights, improve visibility, and support confident decisions.',
      icon: 'ri-bar-chart-box-line'
    }
  ];

  return (
    <section id="solutions" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>
            What Annalogix Delivers
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {solutions.map((solution, index) => (
            <div 
              key={index}
              className="bg-white p-8 rounded-xl border border-gray-200 hover:border-blue-200 hover:shadow-lg transition-all duration-300 group"
            >
              <div className="w-12 h-12 flex items-center justify-center mb-6">
                <i className={`${solution.icon} text-3xl text-blue-500 group-hover:scale-110 transition-transform`}></i>
              </div>
              
              <div className="border-b-2 border-blue-500 w-12 mb-4"></div>
              
              <h3 className="text-xl font-bold text-gray-900 mb-4">
                {solution.title}
              </h3>
              
              <p className="text-sm text-gray-600 leading-relaxed">
                {solution.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
